// extracted by mini-css-extract-plugin
export default {"themeToggler":"ThemeToggler_themeToggler__Kzs5i","themeIcon":"ThemeToggler_themeIcon__3Ftcu"};